(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pirate-halloween-atmosphere"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pirate-atmosphere')) {
  customElements.define('pirate-atmosphere', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.preference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.page = this.closest('main') || this.parentElement;
      this.page.classList.add('ha-page');
      this.paused = this.dataset.enabled !== 'true' || this.preference.matches;
      this.applyMotion = () => {
        const running = !this.paused && !this.preference.matches && !document.hidden;
        this.classList.toggle('ha-running', running);
        this.page.classList.toggle('ha-motion-paused', this.paused || this.preference.matches);
        if (!running) this.animations?.forEach(animation => animation.finish());
      };
      this.preference.addEventListener('change', this.applyMotion, {signal:this.controller.signal});
      document.addEventListener('visibilitychange', this.applyMotion, {signal:this.controller.signal});
      this.animations = [];
      if ('IntersectionObserver' in window && !window.Shopify?.designMode) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            if (!this.paused && !this.preference.matches && entry.target.animate) {
              this.animations.push(entry.target.animate([{opacity:.5,transform:'translateY(16px)'},{opacity:1,transform:'translateY(0)'}], {duration:650,delay:Number(entry.target.dataset.haStagger || 0)*70,easing:'cubic-bezier(.2,.7,.2,1)'}));
            }
            this.observer.unobserve(entry.target);
          });
        }, {threshold:.12});
        this.page.querySelectorAll('.pirate-bundle-visual__header, .pirate-style-steps__top, .pirate-trust__header, .pirate-bundle-card, .pirate-style-step, .pirate-review-card, .pirate-trust-card, .pe-card').forEach((element,index) => {element.dataset.haStagger = index % 4;this.observer.observe(element);});
      }
      this.applyMotion();
    }
    disconnectedCallback() {this.controller?.abort();this.observer?.disconnect();this.animations?.forEach(animation => animation.cancel());this.page?.classList.remove('ha-page','ha-motion-paused');}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pirate-muted-loop-video"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pirate-loop-video')) {
  customElements.define('pirate-loop-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      if (!this.video || !this.button) return;
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.preference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.manuallyPaused = this.preference.matches;
      this.visible = false;
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.loop = true;
      this.button.hidden = false;
      this.sync = () => {
        if (this.manuallyPaused || !this.visible || document.hidden) this.video.pause();
        else this.video.play().catch(() => {});
      };
      this.label = () => {
        const text = this.video.paused ? 'Play video' : 'Pause video';
        this.button.textContent = text;
        this.button.setAttribute('aria-label', text);
      };
      this.video.addEventListener('play', () => {
        if (this.manuallyPaused || !this.visible || document.hidden) this.video.pause();
        this.label();
      }, options);
      this.video.addEventListener('pause', this.label, options);
      this.video.addEventListener('volumechange', () => {
        if (!this.video.muted) this.video.muted = true;
      }, options);
      this.button.addEventListener('click', () => {
        this.manuallyPaused = !this.video.paused;
        this.sync();
        this.label();
      }, options);
      document.addEventListener('visibilitychange', this.sync, options);
      this.preference.addEventListener('change', () => {
        this.manuallyPaused = this.preference.matches;
        this.sync();
      }, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.sync();
        }, {threshold:.15});
        this.observer.observe(this);
      } else {
        this.visible = true;
      }
      this.sync();
      this.label();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.video?.pause();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pirate-sticky-atc"] && !Shopify.designMode) return;
  try {
    
(function () {
  const roots = document.querySelectorAll('[data-pirate-sticky-atc]');
  if (!roots.length) return;

  const money = (cents, currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency
      }).format(Number(cents) / 100);
    } catch (error) {
      return (Number(cents) / 100).toFixed(2);
    }
  };

  roots.forEach((root) => {
    const mainButton = document.querySelector('[data-product-root] form.shopify-product-form button[type="submit"]');
    if (!mainButton) return;

    let hasSeenMainButton = false;

    const visibilityObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          hasSeenMainButton = true;
          root.classList.remove('is-visible');
        } else if (hasSeenMainButton) {
          root.classList.add('is-visible');
        }
      });
    }, { threshold: 0.01 });

    visibilityObserver.observe(mainButton);

    document.addEventListener('theme:variant:change', (event) => {
      const detail = event.detail || {};
      const product = detail.product || {};
      const variant = detail.variant || null;

      if (!variant || String(product.id) !== String(root.dataset.productId)) return;

      const idInput = root.querySelector('input[name="id"]');
      const button = root.querySelector('button[type="submit"]');
      const price = root.querySelector('[data-pirate-sticky-price]');

      if (idInput) idInput.value = variant.id;
      if (price && variant.price != null) {
        price.textContent = money(variant.price, root.dataset.currency);
      }

      if (button) {
        button.disabled = !variant.available;
        button.classList.toggle('disabled--unavailable', !variant.available);
        button.textContent = variant.available ? root.dataset.addLabel : root.dataset.soldLabel;
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
